<template>
  <div
    id="app"
    :class="{
      book: this.$path && this.$path == '/book',
      en: lang === 'EN',
      top: this.btnFlag == false,
      mobile: this.$store.state.webType == 'h5',
      blueNav: this.$path && this.$path.indexOf('articleDetail') > -1,
    }"
    @click=""
  >
    <!-- 菜单展开后的遮罩层 -->
    <div class="fix-model" v-if="currentMenu.unColumn" @click="handleMenuClose"></div>
    <!-- 全部菜单 网站地图 -->
    <div class="abs-line fix-all" v-if="fiexAll && this.$store.state.webType !== 'h5'">
      <div class="fix-left">
        <img src="./assets/images/logo-01.png" class="logo-img" @click="clickGoHome" />
        <div class="logo-info">
          <h1 class="logo-title">WFUCA</h1>
          <span class="logo-title-en">
            <!-- {{ $t("logoTitleBanner") }} -->
            World Federation of UNESCO Clubs and Associations
          </span>
        </div>
      </div>
      <div class="fix-right">
        <i class="el-icon-close" @click="handleFixClose"></i>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane
          :label="menu.unColumn"
          :name="menu.unColumn"
          v-for="(menu, mdx) in menuList"
          :key="mdx"
        >
          <div class="menu-view" v-if="menu.children.length > 0">
            <div class="menu-item" v-for="(child, cdx) in menu.children" :key="cdx">
              <div class="sub-title" @click="goPage(child)">
                {{ child.unColumn }}
              </div>
              <div class="child-view">
                <div class="child-item" v-for="(list, ldx) in child.children" :key="ldx">
                  {{ list.unColumn }}
                </div>
              </div>
            </div>
          </div>
          <div class="menu-view" v-else>
            <div class="menu-item">
              <div class="sub-title" @click="goPage(menu)">
                {{ menu.unColumn }}
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 全部菜单 网站地图 h5-->
    <div class="abs-line fix-all h5" v-if="fiexAll && this.$store.state.webType == 'h5'">
      <div class="fix-left">
        <img src="./assets/images/logo-01.png" class="logo-img" @click="clickGoHome" />
        <div class="logo-info">
          <h1 class="logo-title">WFUCA</h1>
          <span class="logo-title-en">
            <!-- {{ $t("logoTitleBanner") }} -->
            World Federation of UNESCO Clubs and Associations
          </span>
        </div>
      </div>
      <div class="fix-right">
        <i class="el-icon-close" @click="handleFixClose"></i>
      </div>

      <div class="nav-all" v-model="activeName">
        <div
          :label="menu.unColumn"
          :name="menu.unColumn"
          v-for="(menu, mdx) in menuList"
          :key="mdx"
          class="nav-item"
        >
          <div class="menu-view">
            <div class="menu-item">
              <div
                class="sub-title"
                @click="goPage(menu)"
                v-if="menu.path.indexOf('about') == -1 && menu.unColumn.indexOf('News') == -1"
              >
                {{ menu.unColumn }}
              </div>
              <div
                class="sub-title"
                :class="{ active: currentH5Menu == menu.path }"
                @click="handleCurrentSubMenu(menu)"
                v-else
              >
                {{ menu.unColumn }}
                <i v-if="currentH5Menu == menu.path" class="el-icon-arrow-down"></i>
                <i v-else class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div
            class="menu-view"
            v-if="
              menu.children.length > 0 &&
              menu.path.indexOf('strategy') == -1 &&
              currentH5Menu == menu.path
            "
          >
            <div class="menu-item" v-for="(child, cdx) in menu.children" :key="cdx">
              <div
                class="child-title"
                :class="{ active: currentH5Menu == child.path }"
                @click="goPage(child)"
              >
                {{ child.unColumn }}
              </div>
              <!--              <div class="child-view">-->
              <!--                <div class="child-item" v-for="(list, ldx) in child.children" :key="ldx">-->
              <!--                  {{ list.unColumn }}-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 透明菜单 + 展开 -->
    <div
      class="abs-line"
      :class="{ blue: currentMenu.unColumn || navBackgroundBlue }"
      v-if="(this.$store.state.webType === 'pc' && this.scrollTop < 200) || currentMenu.unColumn"
    >
      <div class="fix-left">
        <img src="./assets/images/logo-01.png" class="logo-img" @click="clickGoHome" />
        <div class="logo-info">
          <h1 class="logo-title">WFUCA</h1>
          <span class="logo-title-en">
            <!-- {{ $t("logoTitleBanner") }} -->
            <!-- World Federation of UNESCO Clubs and Associations 5 -->
            World Federation of Clubs and Associations for UNESCO
          </span>
        </div>
      </div>
      <!-- <div class="view-line"> -->
      <!-- 搜索 -->
      <!-- <el-input v-if="isShowSearch" class="search-input" v-model="searchValue"
              @keyup.enter.native="searchArticle(searchValue)" :placeholder="$t('searchTheSite')"></el-input> -->
      <!-- <div class="search-btn" @click="searchArticle(searchValue)">
            {{ $t("search") }}
          </div> -->
      <!-- </div> -->
      <div class="fix-right">
        <div class="right-btn">
          <div class="btn-item nav-all" @click="handleFixAll">
            Quick Links <i class="el-icon-s-unfold"></i>
          </div>
          <div class="btn-item nav-lan">
            <el-dropdown @command="handleCommand" v-if="isShowSearch">
              <span class="el-dropdown-link"
                >{{ langValue }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">English</el-dropdown-item>
                <el-dropdown-item command="b">Français</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <span v-if="!lang || lang != 'EN'" @click="switchLanguage('EN')">English</span>
          <span v-if="lang === 'EN'" @click="switchLanguage('CN')">中文CN</span> -->
            <!-- <span>{{ $t("theQuarterly") }}</span> -->
          </div>
          <!-- <div class="btn-item nav-car" @click="this.$goShopping">
          <img src="@/assets/images/nav-car.png" />
          {{ $t("subscribe") }}
        </div> -->
        </div>
        <el-menu
          v-if="this.$store.state.webType === 'pc'"
          :default-active="activeIndex1"
          :default-openeds="defaultOpens"
          class="el-menu-demo"
          menu-trigger="click"
          mode="horizontal"
          :unique-opened="true"
          @select="handleSelect"
          @open="handleMenuOpen"
          @close="handleMenuClose"
        >
          <template v-for="(item, idx) in menuList">
            <el-menu-item
              v-if="item.children.length == 0 || item.unColumn.indexOf('Plan') > 0"
              :index="`${idx}`"
              @click="goPage(item)"
              >{{ item.unColumn }}</el-menu-item
            >
            <el-submenu v-else :index="`${idx}`">
              <template slot="title">{{ item.unColumn }}</template>
            </el-submenu>
          </template>
          <div><i class="el-icon-search" @click="clickGoSearch"></i></div>
        </el-menu>
      </div>
      <div class="abs-border"></div>
      <!-- 展开的菜单 -->
      <transition name="el-fade-in">
        <!-- :class="{ news: item.unColumn.indexOf('News') > -1 }" -->
        <div
          class="sub-nav-view"
          :class="{ news: currentMenu.unColumn.indexOf('News') > -1 }"
          v-if="currentMenu.unColumn"
        >
          <div class="title-view">
            <div class="title">{{ currentMenu.unColumn }}</div>
            <!--            <div class="text">Text No.3</div>-->
          </div>
          <div class="child-view">
            <div class="child-item" @click="goPage(child)" v-for="child in currentMenu.children">
              <!-- <img src="@/assets/images/about-child01.png" /> -->
              <img :src="child.bannerImg" />
              <div class="child-title">{{ child.unColumn }}</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="el-fade-in">
        <!-- :class="{ news: item.unColumn.indexOf('News') > -1 }" -->
        <div class="sub-nav-view2" :class="{ news: currentFlag }" v-if="currentFlag">
          <div class="search_box">
            <div class="search_input_row">
              <el-input
                v-model="searchStr"
                @change="changeSearchStr"
                placeholder="Please enter keywords for search"
              /><el-button type="primary" round @click="clickSearchBtn"
                >Search <i class="el-icon-search el-icon--right"></i
              ></el-button>
            </div>
            <div class="search_link_row">
              Quick links:<span
                style="text-decoration: underline; margin-left: 10px; margin-right: 10px"
                >UNESCO action in Ukraine</span
              ><span style="text-decoration: underline">World Heritage</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 固定菜单 - 蓝色 单行 -->
    <div class="abs-line fix" @mouseleave="handleMenuClose" v-else>
      <div class="fix-left">
        <img src="./assets/images/logo-01.png" class="logo-img" @click="clickGoHome" />
        <div class="logo-info">
          <h1 class="logo-title">WFUCA</h1>
        </div>
      </div>
      <div class="fix-right">
        <div class="right-btn">
          <div class="btn-item nav-all" @click="handleFixAll">
            Quick Links <i class="el-icon-s-unfold"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- <transition name="fade"> -->
    <div class="menu-child" v-if="allMenuClick">
      <template v-for="(menu, cdx) in menuList">
        <div
          v-if="menu.menuName != '首页' && menu.path != '0'"
          class="child-item"
          :class="{ active: menu.path === $path }"
          @click="goPage(menu)"
        >
          {{ menu.menuName }}
        </div>
      </template>
      <div
        class="child-item"
        :class="{ active: child.path === $path }"
        @click="goPage(child)"
        v-for="(child, cdx) in childMenuList"
        :key="cdx"
      >
        {{ child.lmName }}
      </div>
    </div>
    <!-- </transition> -->
    <!-- v-if="!$route.meta.keepAlive" -->
    <!-- <keep-alive exclude="ArticleDetail,Search,Book"> -->
    <div class="app-view">
      <router-view />
    </div>
    <!-- </keep-alive> -->
    <footer class="footer-view" :class="{ h5: this.$store.state.webType === 'h5' }">
      <div style="position: relative" v-if="false">
        <img class="footer-bg" src="@/assets/images/footer-bg.png" alt="世界联合会" />
        <div class="footer-content">
          <img
            v-if="$store.state.lang == 'CN'"
            class="footer-icon"
            src="@/assets/images/footer-icon.png"
            alt=""
          />
          <img v-else class="footer-icon" src="@/assets/images/footer-icon-en.png" alt="" />
          <div class="link-view">
            <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-01.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-11.png" />
              </div>
            </div>
            <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-02.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-22.png" />
              </div>
            </div>
            <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-03.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-33.png" />
              </div>
            </div>
            <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-04.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-44.png" />
              </div>
            </div>
            <!-- <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-05.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-55.png" />
              </div>
            </div>
            <div
              v-if="$store.state.webType === 'h5'"
              style="width: 100%; height: 6px"
            ></div>
            <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-06.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-66.png" />
              </div>
            </div>
            <div class="item-view">
              <img class="link-item" src="@/assets/images/footer-link-07.png" />
              <div>
                <img class="link-bg" src="@/assets/images/link-item-bg.png" />
                <img class="link" src="@/assets/images/footer-link-77.png" />
              </div>
            </div>
            <img
              class="link-item"
              @click="
                windowOpen(
                  'https://www.facebook.com/China-News-Release-106059441916413/',
                  '_blank'
                )
              "
              src="@/assets/images/footer-link01.png"
            />
            <img
              class="link-item"
              @click="
                windowOpen(
                  'https://twitter.com/zgxwfb?t=8jNydSLBYI2pHPFnkpiHGg&s=09',
                  '_blank'
                )
              "
              src="@/assets/images/footer-link02.png"
            />
            <img
              class="link-item"
              @click="
                windowOpen(
                  'https://youtube.com/channel/UCcMHW5dnzkK8w6Gb7EQRIKQ',
                  '_blank'
                )
              "
              src="@/assets/images/footer-link03.png"
            /> -->
          </div>
        </div>
      </div>
      <div class="footer-bottom" :class="{ pd: $store.state.lang == 'EN' }">
        <div>Copyright©2024-WFUCA</div>
        <div style="margin-left: auto">Map ｜ Statement ｜ Mail</div>
      </div>
    </footer>
  </div>
</template>

<script>
// 在需要的组件中引入切换的方法
import { setI18nLanguage } from "./lang/index";
// const dlMenu = ["", "", "", "", ""];
export default {
  data() {
    return {
      defaultOpens: [],
      langValue: "",
      htmlShow: false,
      childName: "",
      allMenuClick: false,
      btnFlag: false, // 记录当前返回顶部标志的可视状态
      scrollTop: 0, // 当前滚动位置
      fiexAll: false,
      activeReady: false,
      activeName: "Home",
      menuList: [],
      childMenuList: [],
      searchValue: "",
      searchShow: false,
      webLinks: {
        tvUrl: "",
      },
      isPlay: false,
      lang: "FR",
      player: false,
      activeIndex2: "home",
      activeIndex1: "1",
      isShowSearch: true,
      currentMenu: {},
      currentFlag: false,
      searchStr: "",
      currentH5Menu: "",
      navBackgroundBlue: false, // 特定页面 导航变蓝色
    };
  },

  created() {
    window.addEventListener(
      "popstate",
      (e) => {
        const that = this;
        setTimeout(() => {
          console.log(that.$route.path);
          const { path } = that.$route;

          that.$store.state.menuList.forEach((menu, index) => {
            console.log(menu.path, "-----------", menu.path === path, path);
            // console.log(menu);
            if (menu.path === path) {
              if (menu.menuNameEnglish) {
                that.scrollLeftTo(menu.menuNameEnglish);
                that.childName = "";
              } else {
                that.scrollLeftTo("All");
                // this.childName =
                //   this.$store.state.lang == "CN" ? obj.lmName : obj.lmNameEnglish;
                that.childName = menu.lmName;
                // console.log(that.childName);
              }
            }
          });
        }, 100);
      },
      false
    );
    window.addEventListener("scroll", this.scrollToTop); // 监听滚动条
    // 获取当前语言
    this.lang = localStorage.getItem("lang");
    const lang = this.getQueryString("lang");
    // console.log(lang);
    if (this.getQueryString("lang")) {
      localStorage.setItem("lang", lang);
      this.$store.commit("setLang", lang);
      this.lang = lang;
      setI18nLanguage(lang);
    } else if (this.lang && this.lang === "FR") {
      this.$store.commit("setLang", "FR");
      this.lang = "FR";
    } else {
      //默认英文
      localStorage.setItem("lang", "EN");
      this.$store.commit("setLang", "EN");
      this.lang = "EN";
    }

    const that = this;
    // 检测设备屏幕宽度
    if (document.body.offsetWidth < 980) {
      that.$store.commit("setWebType", "h5");
      this.activeReady = false;
    } else {
      that.$store.commit("setWebType", "pc");
    }
    window.addEventListener("resize", () => {
      that.screenWidth = document.body.offsetWidth;
      // console.log("window.screenWidth", document.body.offsetWidth);
      if (document.body.offsetWidth < 980) {
        that.$store.commit("setWebType", "h5");
        that.activeReady = false;
      } else {
        // that.scrollLeftTo(this.activeName);
        that.$store.commit("setWebType", "pc");
      }
    });
    // console.log('this.$route.query', this.$route.query);
    // console.log('this.$path', this.$path);

    const token = this.getQueryString("token");
    // console.log(token);
    if (token) {
      sessionStorage.setItem("token", token);
    }
    this.$appType.name = this.$store.state.webType;
    // if (this.menuList.length == 0) {
    this.getMenuList();
    // console.log(sessionStorage.getItem("webLinks"));
    // if (
    //   window.location.href.indexOf("token") === -1 &&
    //   window.location.href.indexOf("lang") === -1
    // ) {
    //   // 非预览
    //   // 如果是移动设备  不播放视频
    //   if (this.$store.state.webType == "h5") {
    //     this.isPlay = false;
    //     sessionStorage.setItem("isPlay", 1);
    //   } else {
    //     if (sessionStorage.getItem("isPlay") != 1) {
    //       if (window.location.href.indexOf("book") === -1) {
    //         this.isPlay = true;
    //       }
    //     } else {
    //       this.isPlay = false;
    //     }
    //   }
    // } else {
    //   // 预览
    //   this.isPlay = false;
    //   sessionStorage.setItem("isPlay", 1);
    //   // console.log(this.webLinks);
    // }

    // this.videoTimer = setInterval(() => {
    //   that.$nextTick(() => {
    //     // console.log("playVideo", this.isPlay);
    //     if (that.player == false && this.isPlay == true) {
    //       that.playVideo();
    //     } else {
    //       clearInterval(that.videoTimer);
    //     }
    //   });
    // }, 500);
  },
  destroyed() {
    localStorage.setItem("lang", this.$store.state.lang);
    window.removeEventListener("scroll", this.scrollToTop); // 移除滚动条监听
  },

  mounted() {
    if (this.$route.name === "AboutWorld" || this.$route.name === "AboutSession") {
      this.navBackgroundBlue = true;
    } else {
      this.navBackgroundBlue = false;
    }
    if (this.lang === "FR") {
      this.langValue = "Français";
    } else if (this.lang === "EN") {
      this.langValue = "English";
    }
  },
  computed: {
    listenRoutePathState() {
      return this.$store.state.routePath;
    },
  },
  watch: {
    $route(to, from) {
      console.log(to, "to", from);
      if (to.name == "AboutWorld" || to.name == "AboutSession") {
        this.navBackgroundBlue = true;
      } else {
        this.navBackgroundBlue = false;
      }
      if (to.name == "PublishEvents") {
        this.isShowSearch = false;
        this.activeIndex2 = "Publish Events";
        this.menuList = [
          {
            unColumn: "Publish Events",
          },
          {
            unColumn: "Publish News",
          },
          {
            unColumn: "Publish List",
          },
        ];
      }
    },
    //监听全局变量componentId的变化
    listenRoutePathState: function (val, oldval) {
      // console.log(val, oldval);
      this.menuList.forEach((value) => {
        // console.log(value);
        if (value.path == this.$path) {
          // this.childName = value.lmName;
          // console.log(value);
          this.scrollLeftTo(value.menuNameEnglish);
        }
      });
      // if (val != this.compId) {
      //   this.showPop = false;
      // }
    },
  },
  methods: {
    handleCurrentSubMenu(menu) {
      if (this.currentH5Menu === menu.path) {
        this.currentH5Menu = "";
      } else {
        this.currentH5Menu = menu.path;
      }
    },
    clickSearchBtn() {
      console.log(this.searchStr, "ser");
      this.currentFlag = false;
      this.$router.push({
        path: "/search",
        query: { value: this.searchStr },
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
    changeSearchStr(val) {
      this.searchStr = val;
    },
    clickGoSearch() {
      console.log("搜索结果页跳转");
      this.currentFlag = true;
      // this.currentMenu.unColumn = "search";
      //  this.$router.push({ path: "/search" });
      // document.getElementsByClassName("abs-line")[0].style.background = "#0077d4";
    },
    handleFixAll() {
      this.fiexAll = true;
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    handleFixClose() {
      this.fiexAll = false;
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    clickGoHome() {
      this.goPage("/");
      this.activeIndex2 = "Home";
      this.getMenuList();
    },
    handleMenuOpen(key, keyPath) {
      console.log("handleSelect", key, keyPath);
      this.currentFlag = false;
      this.currentMenu = this.menuList[key];
      console.log(this.currentMenu, "currentMenu-->");
    },
    handleMenuClose() {
      this.currentMenu = {};
      this.defaultOpens = [];
    },
    handleSelect(key, keyPath) {
      this.currentFlag = false;
      console.log("handleSelect", key, keyPath);
      if (key == "Home" || key == "Back Home") {
        this.goPage("/");
        this.activeIndex2 = "Home";
      } else if (key == "Events") {
        // this.goPage("/cxsm");
        this.$router.push("/events");
        this.activeIndex2 = "Events";
      } else if (key == "News") {
        this.$router.push("/news");
        this.activeIndex2 = "News";
      } else if (key == "Governance") {
        // this.$router.push("/benkanpinglun");
        this.$router.push("/governance");
        this.activeIndex2 = "Governance";
      } else if (key == "Members") {
        this.$router.push("/wzyy");
        this.activeIndex2 = "Members";
      } else if (key == "About Us") {
        this.$router.push("/xzc");
        this.activeIndex2 = "About Us";
      } else if (key == "Publish Events") {
        this.$router.push("/publishevents");
        this.activeIndex2 = "Publish Events";
      } else if (key == "Publish News") {
        this.$router.push("/publishnews");
        this.activeIndex2 = "Publish News";
      } else if (key == "Publish List") {
        this.$router.push("/publishlist");
        this.activeIndex2 = "Publish List";
      }
    },
    handleCommand(command) {
      this.langValue = command == "a" ? "Français" : "English";
      if (command == "a") {
        this.switchLanguage("EN");
      } else {
        this.switchLanguage("FR");
      }
    },
    allMenuShow() {
      this.allMenuClick = !this.allMenuClick;
    },

    goContact() {
      this.$router.push("/about");
    },
    // 为了计算距离顶部的高度，当高度大于200显示回顶部图标，小于200则隐藏
    scrollToTop() {
      const that = this;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      // console.log(that.scrollTop);
      if (that.scrollTop > 200) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    playVideo() {
      const that = this;
      this.$nextTick(() => {
        that.$refs.homeVideo.play();
        that.player = true;
        clearInterval(that.videoTimer);
      });
      // console.log(this.$refs.homeVideo.play);
    },
    getQueryString(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    toggleActive() {
      this.activeReady = !this.activeReady;
    },
    // 切换语言方法
    switchLanguage(lang) {
      // setI18nLanguage(lang);
      // // 将语言放入localStorage，在初始化语言时取出，从而刷新页面时，不会恢复初始语言
      // localStorage.setItem("lang", lang);
      // this.lang = lang;
      // this.$router.push("/");
      // location.reload();

      const routeData = this.$router.resolve({
        path: "/",
        query: { lang },
      });
      // window.open(routeData.href, "_blank");
      window.open(routeData.href, "_self");
    },
    handleExitFullScreen(e) {
      // console.log(e);
      this.isPlay = false;
      sessionStorage.setItem("isPlay", 1);
      // this.exitFullscreen(e.target);
    },
    windowOpen(url, type) {
      window.open(url, type);
    },
    // 获取网站设置
    getLinks() {
      this.$get(`${this.$api}/cms/web/getLinks`).then((res) => {
        // console.log(res);
        const obj = res.data;
        for (const key in obj) {
          typeof obj[key];
          if (obj[key]) {
            this.webLinks[key] = JSON.parse(obj[key]);
            // console.log(this.webLinks);
          }
        }
        // console.log(this.webLinks);
        sessionStorage.setItem("webLinks", JSON.stringify(this.webLinks));
      });
    },
    searchArticle(val) {
      this.searchShow = false;
      this.searchValue = "";
      this.$router.push({
        path: "/search",
        query: { value: val },
      });
    },

    // async getNewMenuList() {
    //   await this.$get(`${this.$api}/un/web/column`, {}).then((res) => {
    //     this.menuList = res.data;
    //   });
    // },
    getMenuList() {
      this.menuList = this.$store.state.menuList;
      //alert(11+"  "+JSON.stringify(this.menuList));
      this.$get(`${this.$api}/un/web/column`, { language: "EN" }).then((res) => {
        this.menuList = res.data;
        //alert(22+"  "+JSON.stringify(this.menuList));
      });
    },
    goPage(obj) {
      this.currentH5Menu = "";
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
      this.fiexAll = false;
      console.log("obj", obj);
      if (obj.path === "/events") {
        this.$router.push({ path: "/news", query: { type: "Events" } });
        setTimeout(() => {
          this.$router.go(0);
        });
        return;
      }
      if (obj.path === "/news") {
        this.$router.push({ path: "/news", query: { type: "News" } });
        setTimeout(() => {
          this.$router.go(0);
        });
        return;
      }
      if (obj.path === "/article" && this.$store.state.webType == "h5") {
        this.$router.push({ path: "/news", query: { type: "News" } });
        setTimeout(() => {
          this.$router.go(0);
        });
        return;
      }
      if (obj == "All") {
        this.allMenuClick = !this.allMenuClick;
        return;
      }
      if (obj === "/") {
        obj = {
          cnPart: null,
          columnId: null,
          menuId: 1084,
          menuName: "首页",
          menuNameEnglish: "Home",
          path: "/",
        };
      }

      if (obj.path != 0 && obj.path !== this.$path) {
        this.$router.push(obj.path);
        if (this.$store.state.webType == "h5") {
          this.activeReady = false;
        } else {
          this.activeReady = true;
        }

        // 触发滑动方法
        // console.log(obj);
        if (obj.menuNameEnglish) {
          this.scrollLeftTo(obj.menuNameEnglish);
          this.childName = "";
        } else {
          this.scrollLeftTo("All");
          // this.childName =
          //   this.$store.state.lang == "CN" ? obj.lmName : obj.lmNameEnglish;
          this.childName = obj.lmName;
          // console.log(this.childName);
        }
      }
      this.handleMenuClose();
    },
    // 滑动
    scrollLeftTo(name) {
      // console.log(name);
      this.allMenuClick = false;
      this.$nextTick(() => {
        const ref = `tab${name}Ref`;
        this.activeName = name;
        // console.log(this.activeName);
        // 获取myTabRef的DOM元素，即类名为my-tab的标签
        const nav = this.$refs.myTabRef;
        const active = this.$refs.navActive.style;

        // 获取当前点击的某一个tab的的DOM元素，即类名为my-tab-item的标签
        const title = this.$refs[ref][0];
        // console.log(nav.offsetWidth, title.offsetLeft);
        // console.log("nav", nav, title);
        // 计算位移偏差
        const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
        // console.log(to);
        // console.log(title.offsetLeft, title.offsetWidth);
        active.left = `${title.offsetLeft + title.offsetWidth / 2}px`;
        // active.scrollLeft = to;
      });
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
<style lang="scss">
.page-header {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.t-anchor__item {
  margin-bottom: fh(40vh, pc);
  &.t-is-active {
    font-weight: bold;
  }
  a {
    font-size: fh(16vh, pc);
    line-height: fh(20vh, pc);
  }
}
.drawer-fixed {
  .el-drawer {
    width: 68%;
    left: 16%;
    height: 100% !important;
    .drawer-view {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      .drawer-media {
        width: 100%;
      }
      .info {
        padding: fh(40vh, pc) fw(40vw, pc);
        h2 {
          font-size: fh(24vh, pc);
          line-height: fh(36vh, pc);
          color: #333;
          font-weight: bold;
        }
        .date {
          font-size: fh(18vh, pc);
          line-height: fh(24vh, pc);
          padding: fh(20vh, pc) 0;
          color: #999999;
        }
        .a {
          font-size: fh(18vh, pc);
          line-height: fh(22vh, pc);
          color: #333333;
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
ul,
li {
  list-style-type: none; //去掉标签默认的左边符号
}
.app-view {
  width: 100vw;
  min-height: 100vh;
  // margin-top: 119px;
}
.more-btn {
  width: fw(200vw, pc);
  height: fh(40vh, pc);
  line-height: fh(40vh, pc);
  font-size: fh(16vh, pc);
  background: #0077d4;
  border-radius: fh(20vh, pc);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  i {
    margin-left: fw(4vw, pc);
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 120, 212, 0.8);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.book .navbar,
.book .footer-view {
  display: none !important;
}

.el-carousel__arrow {
  width: 50px;
  height: 50px;
  font-size: 25px;
  background-color: rgba(31, 45, 61, 0.5);
}

.footer-view {
  position: relative;
  width: 100vw;
  box-sizing: border-box;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.21) 100%);
    // opacity: 0.5;
    z-index: 9;
  }

  .footer-content {
    width: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99;
    left: 0;
    padding-left: fw(140vw, pc);

    .footer-icon {
      width: fw(500vw, pc);
    }

    .link-view {
      display: flex;
      align-items: center;
      margin-right: fw(40vw, pc);
      flex-wrap: wrap;
      margin-left: auto;

      .link-item {
        margin-right: fw(40vw, pc);
        width: fw(48vw, pc);
        border-radius: 50%;
        position: relative;
        cursor: pointer;
      }

      .item-view {
        position: relative;

        > div {
          display: none;
          width: fw(140vw, pc);
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-64%) translateY(-100%);

          .link-bg {
            width: fw(140vw, pc);
          }

          .link {
            position: absolute;
            top: fw(6vw, pc);
            left: fw(10vw, pc);
            width: fw(120vw, pc);
          }

          img {
            display: block;
          }
        }

        &:hover {
          > div {
            display: block;
          }
        }
      }
    }
  }

  .footer-bg {
    width: 100%;
    display: block;
  }

  .footer-bottom {
    position: relative;
    z-index: 99;
    background-color: #0077d4;
    color: #fff;
    display: flex;
    width: 100%;
    padding: fh(12vh, pc) fw(380vw, pc);
    font-size: fh(16vh, pc);
    line-height: fh(24vh, pc);
    // padding-left: fw(680vw, pc);
    margin-top: -2px;
    font-weight: 400;

    &.pd {
      justify-content: center;
    }

    div {
      margin-right: fw(60vw, pc);

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }
}

.footer-view.h5 {
  .footer-content {
    display: flex;
    align-items: center;
    top: 50%;
    transform: translateY(-50%);

    .footer-icon {
      width: 42%;
    }

    .link-view {
      flex: 1;
      margin-left: fw(20vw, h5);
      margin-top: 0;

      // justify-content: space-around;
      // margin-right: fw(30vw, h5);
      .link-item {
        width: 10%;
        display: block;
      }

      .item-view {
        width: 10%;
        margin-right: fw(40vw, pc);

        .link-item {
          // margin-right: 0;
          width: 100%;
        }

        > div {
          width: fw(100vw, h5);
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%) translateY(-100%);

          .link-bg {
            width: fw(100vw, h5);
          }

          .link {
            position: absolute;
            top: fw(6vw, h5);
            left: fw(10vw, h5);
            width: fw(80vw, h5);
          }

          img {
            display: block;
          }
        }

        &:hover {
          > div {
            display: block;
          }
        }
      }
    }
  }

  .footer-bottom {
    padding: 10px 20px;
    flex-wrap: wrap;

    div {
      width: 100%;
      margin: 5px 0;
      text-align: center;
    }
  }
}

.nav-h5 {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100vw;
  display: flex;
  align-items: center;
  background: #edf1f3;
  padding: 8px 20px;
  justify-content: space-between;

  &.all {
    background: rgba(15, 0, 0, 1);
  }

  .nav-menu {
    position: fixed;
    width: 100%;
    top: 40px;
    left: 0;
    background-color: #f5f5f5;
    padding: fh(5vh, h5) fw(20vw, h5);
    height: 100vh;
    z-index: 999;
    border-top: 1px solid #e9e9e9;

    > div {
      display: flex;
      flex-wrap: wrap;

      .menu-item {
        // background: #e9e9e9;
        color: $sh;
        width: 50%;
        padding: fh(15vh, h5) 0;
        border-bottom: 1px solid #e9e9e9;
        text-align: center;
        &.disabled {
          color: #999;
          cursor: auto;
        }

        &.active {
          color: #0046b4;
          font-weight: bold;
        }

        &.nav-level.active {
          color: #fff;
        }

        &:nth-child(odd) {
          border-right: 1px solid #e9e9e9;
        }

        &:nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
  }

  img {
    display: block;
  }

  .menu-icon {
    width: 24px;
  }

  .nav-icon {
    position: absolute;
    left: 50%;
    top: 8px;
    width: 120px;
    transform: translateX(-50%);
  }

  .btn-item {
    display: flex;
    align-items: center;
    font-size: 16px;
    // padding-right: fw(100vw, pc);
    color: #515151;

    img {
      width: 20px;
      display: block;
      margin-right: 4px;
      opacity: 0.7;

      &:hover {
        color: $zh;
        cursor: pointer;
      }
    }
  }
}

.top .page {
  // padding-top: fh(40vh, pc) !important;
}

.el-menu > .el-menu-item,
.el-menu > .el-submenu__title,
.el-submenu__title {
  font-size: fh(15vh, pc);
  font-size: fh(20vh, pc);
  font-family: "Open Sans", sans-serif;
  padding: 0 !important;
  margin-right: fw(40vw, pc);
  color: #fff;

  &:hover {
    color: #fff;
  }
}
.el-menu--popup {
  background-color: transparent;
  display: none;
}
.sub-nav-view2 {
  background-color: #fff;
  background: linear-gradient(to bottom, #0077d4, #fff);
  position: absolute;
  right: 0;
  top: fh(110vh, pc);
  width: 100vw;
  color: #fff;
  height: fh(418vh, pc);
  display: flex;
  justify-content: center;
  align-items: center;
}
.search_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.search_input_row {
  display: flex;
  width: 40%;
  margin-bottom: 20px;
}
.search_input_row .el-input__inner {
  border-radius: 25px;
}
.search_input_row .el-input {
  margin-right: 10px;
}
.search_link_row {
  // text-align: center;
  margin-left: -7%;
  color: #1b1a1a;
}
.sub-nav-view {
  background-color: #0077d4;
  position: absolute;
  right: 0;
  top: fh(90vh, pc);
  width: 100vw;
  color: #fff;
  height: fh(418vh, pc);
  display: flex;
  padding-top: fh(10vh, pc);
  .title-view {
    width: fw(650vw, pc);
    padding-left: fw(140vw, pc);
    padding-top: fh(60vh, pc);
    .title {
      font-size: fh(48vh, pc);
      line-height: fh(58vh, pc);
      font-weight: bold;
    }
    .text {
      font-size: fh(18vh, pc);
      line-height: fh(22vh, pc);
      margin-top: fh(18vh, pc);
    }
  }
  .child-view {
    display: flex;
    flex: 1;
    .child-item {
      margin: fh(40vh, pc) fw(20vw, pc);
      //width: fw(320vw, pc);
      width: fw(493vw, pc);
      height: fw(300vw, pc);
      display: flex;
      position: relative;
      border-radius: 20px;
      overflow: hidden;
      &:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      &::before {
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
      }
      img {
        width: 100%;
        display: block;
      }
      .child-title {
        font-size: fh(24vh, pc);
        line-height: fh(30vh, pc);
        position: absolute;
        left: 50%;
        top: 50%;
        text-align: center;
        transform: translate(-50%, -50%);
        width: 100%;
      }
    }
  }
  &.news {
    .child-view .child-item {
      width: fw(493vw, pc) !important;
    }
  }
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #fff !important;
  height: 2rem;
  line-height: 2.12rem;
  font-size: fh(15vh, pc);
  font-size: fh(20vh, pc);
  font-weight: 500;
  &:hover {
    background-color: transparent;
    color: #fff !important;
  }
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: #fff !important;
  border-color: #fff !important;
}

.el-menu > .is-active {
  border-bottom-color: #fff !important;
}

.el-submenu__title {
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  // font-weight: bold;
  color: #fff;
}
.el-menu-demo {
  position: relative !important;
  // padding-left: 10%;
  display: flex;
  align-items: center;
  width: max-content;
  border: none !important;
  background-color: transparent !important;
  margin-left: auto;
  margin-top: fh(25vh, pc);
  margin-bottom: -10px;
  .el-menu-item {
    height: 2rem;
    line-height: 2.12rem;
    text-underline-offset: 8px; //下划线和文字间距
    &:active,
    &.is-active {
      background-color: transparent !important;
    }
  }

  .el-submenu__icon-arrow {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }
}

.blueNav .abs-line,
.blue.abs-line {
  background-color: #0077d4 !important;
}
.fix-model {
  // display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background-color: rgba(0, 0, 0, 0.432);
  z-index: 88;
}
.abs-line {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  // height: fh(108vh, pc);
  // background: linear-gradient(90deg, #6d9dff 0%, #3b64fd 100%);
  padding: fh(25vh, pc) fw(60vw, pc) fh(20vh, pc) fw(60vw, pc);
  &.fix-all {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #0077d4;
    z-index: 99999;
    align-items: flex-start;
    flex-wrap: wrap;
    cursor: none;
    .fix-right {
      position: absolute;
      top: fh(40vh, pc);
      right: fw(60vw, pc);
      font-size: fh(18vh, pc);
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      padding: fw(10vw, pc);
      &:hover {
        cursor: pointer;
        background-color: #000;
      }
    }
    .el-tabs__content {
      padding: fh(60vh, pc) fw(130vw, pc);
      .menu-view {
        font-size: fh(18vh, pc);
        line-height: fh(28vh, pc);
        display: flex;
        width: 100%;
        .menu-item {
          margin-right: fw(100vw, pc);
          .sub-title {
            font-weight: bold;
          }
          .child-view {
            .child-item {
              font-size: fh(16vh, pc);
              line-height: fh(24vh, pc);
              margin-top: fh(40vh, pc);
              color: #fff;
            }
          }
        }
      }
    }
    .fix-left {
      width: 100%;
    }
    .el-tabs {
      position: absolute;
      top: fh(138vh, pc);
      left: fw(60vw, pc);
      width: fw(1800vw, pc);
      .el-tabs__nav-wrap::after {
        height: 1px;
        background-color: rgba(255, 255, 255, 0.5);
      }
      .el-tabs__nav {
        display: flex;
        width: 100%;
        justify-content: space-between;
      }
      .el-tabs__item {
        color: rgba(255, 255, 255, 0.5);
        font-size: fh(24vh, pc);
        line-height: fh(36vh, pc);
        font-weight: bold;
        padding: fh(42vh, pc) 0;
        height: auto;
        &.is-active {
          color: #fff;
          &::before {
            position: absolute;
            content: "";
            width: 100%;
            bottom: 0;
            left: 0;
            height: 2px;
            background-color: #fff;
            z-index: 1;
            transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            list-style: none;
          }
        }
      }
      .el-tabs__active-bar {
        display: none;
      }
    }
  }
  &.fix {
    position: fixed;
    background-color: #0077d4;
    padding: fh(12vh, pc) fw(60vw, pc) fh(12vh, pc) fw(60vw, pc);
    align-items: center;
    .fix-left {
      align-items: center;
    }
  }
  .abs-border {
    position: relative;
    width: fw(1800vw, pc);
    height: 1px;
    position: absolute;
    left: fw(60vw, pc);
    bottom: 0;
    background-color: #888888;
    z-index: 100;
  }
  &:hover {
    background: rgba(0, 120, 212, 1);
    cursor: pointer;
  }
  .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
    color: #fff !important;
  }
  .fix-left {
    display: flex;

    .logo-info {
      display: flex;
      flex-flow: column;
      flex-wrap: nowrap;
      width: -webkit-max-content;
      width: -moz-max-content;
      width: max-content;
      justify-content: space-between;
      margin-left: fw(20vw, pc);
      color: #fff;

      .logo-title {
        width: 100%;
        font-family: "Open Sans", sans-serif;
        font-size: fh(28vh, pc);
        font-size: fh(38vh, pc);
        line-height: fh(34vh, pc);
        font-weight: bolder;
      }

      .logo-title-en {
        font-family: "Open Sans", sans-serif;
        font-size: fh(12vh, pc);
        line-height: fh(14vh, pc);
        // color: #757575;
      }
    }
  }

  .fix-right {
    position: relative;
    flex: 1;
    display: flex;
    flex-flow: column;
    flex-wrap: nowrap;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    justify-content: space-between;

    .right-btn {
      position: absolute;
      right: 0 !important;
      top: fh(-12vh, pc);
      margin-top: fh(-2vh, pc);
      display: flex;
      align-items: center;
      color: #fff;

      .nav-all {
        &:hover {
          opacity: 0.8;
          color: #fff;
          cursor: pointer;
        }
      }

      .nav-lan {
        margin-left: fw(60vw, pc);
        color: #fff !important;
        cursor: pointer;
      }

      .el-dropdown {
        color: #fff !important;
      }
    }
  }

  .logo-img {
    // height: fh(78vh, pc);
    width: fw(60vw, pc);
    margin-left: fw(0vw, pc);
  }

  .nav-btn {
    width: 100%;
    margin-left: auto;
    display: flex;
    flex: 1;
    align-items: center;

    .btn-item {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.5);

      img {
        width: fw(24vw, pc);
        display: block;
        margin-right: fw(8vw, pc);
        opacity: 0.7;

        &:hover {
          color: #fff;
          cursor: pointer;
        }
      }

      &.nav-search img {
        width: fw(32vw, pc);
      }

      &:hover {
        img {
          opacity: 1;
        }
      }

      &.nav-lan {
        border-left: 1px solid rgba(255, 255, 255, 0.5);
        border-right: 1px solid rgba(255, 255, 255, 0.5);
        margin: 0 fw(36vw, pc);

        span {
          display: block;
          text-align: center;
          width: max-content;
          margin: 0 fw(16vw, pc);

          &:hover {
            // color: #fff;
            cursor: pointer;
          }
        }
      }

      &.nav-car:hover {
        color: #fff;
        cursor: pointer;
      }
    }
  }
}

.top .menu-child {
  position: relative;
  top: 0 !important;
}

.menu-child {
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100vw;
  // background: #e9e9e9;
  top: fh(110vh, pc);
  left: 0;
  padding: 0 fh(80vh, pc);
  padding-bottom: fh(40vh, pc);
  z-index: 9;
  opacity: 1 !important;
  background-color: #dee5ff;
  z-index: 999;

  .child-item {
    color: rgba(251, 254, 255, 0.8);
    font-weight: normal;
    margin-right: fw(40vw, pc);
    margin-top: fh(40vh, pc);
    font-size: fh(20vh, pc);
    color: #535353;
    line-height: fh(30vh, pc);

    &:hover {
      cursor: pointer;
      color: #0046b4;
      opacity: 0.8;
    }

    &.active {
      color: #0046b4;
      color: $zh;
      font-weight: bold;
      // color: $zh;
    }
  }

  /*display: none;*/
}

.top .navbar {
  position: relative;
  top: 0;
}

.navbar {
  position: fixed;
  left: 0;
  top: fh(106vh, pc);
  z-index: 999;
  display: flex;
  align-items: center;
  width: 100vw;
  background: #1e73be;
  color: #535353;
  color: #fff;
  font-size: fh(16vh, pc);
  min-height: fh(68vh, pc);
  /*padding: fh(14vh, pc) fw(80vw, pc) fh(14vh, pc) fw(40vw, pc);*/

  .nav-icon {
    width: fw(180vw, pc);
    color: $zh;
    margin-left: fw(40vw, pc);

    .cn {
      font-size: fh(26vh, pc);
      margin-bottom: fh(2vh, pc);
    }

    .en {
      font-size: fh(14vh, pc);
    }
  }

  .nav-icon:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .nav-menu {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: stretch;

    // position: relative;
    .menu-item {
      position: relative;
      margin: 0 fw(6vw, pc);
      padding: 0 fw(6vw, pc);
      flex-shrink: 0;
      height: fh(68vh, pc);
      display: flex;
      align-items: center;
      font-size: fh(10vw, pc);
      &:hover {
        background-color: transparent !important;
      }
      &.disabled {
        color: #999;

        &:hover {
          // font-weight: bold;
          cursor: no-drop;
        }
      }

      &.nav-level {
        margin-left: fw(60vw, pc);
        padding: 0 fw(25vw, pc);

        span {
          color: #686a67 !important;
          font-size: fh(10vh, pc);
          margin-left: fw(8vw, pc);
          transform: rotate(-90deg);
          transition: transform 300ms;
        }

        &.child {
          color: $zh !important;
          font-weight: bold;
          background: #e9e9e9;
        }

        &.active {
          // color: #535353;
          color: #fff;
          background: #dee5ff;

          span {
            transform: rotate(90deg);
          }
        }
      }

      &.active {
        // font-size: fh(18vh, pc);
        font-weight: bold;
        // color: #0046b4;
        color: #fff;
      }
    }

    .nav-active {
      position: absolute;
      width: fw(40vw, pc);
      height: fh(4vh, pc);
      // background-color: $zh;
      bottom: fw(4vh, pc);
      transform: translateX(-50%);
      transition: left 0.3s;
    }

    &.no {
      .menu-item.active {
        &::after {
          content: "";
          position: absolute;
          width: fw(40vw, pc);
          height: fh(4vh, pc);
          background-color: $zh;
          left: 50%;
          bottom: fw(4vh, pc);
          transform: translateX(-50%);
        }
      }
    }

    // .menu-item.active
    .menu-item:hover {
      // font-weight: bold;
      cursor: pointer;
      opacity: 0.8;
      // &::after {
      //   content: "";
      //   position: absolute;
      //   width: fw(40vw, pc);
      //   height: fh(4vh, pc);
      //   background-color: $zh;
      //   left: 50%;
      //   bottom: fw(4vh, pc);
      //   transform: translateX(-50%);
      // }
    }
  }

  .search-iew {
    position: absolute;
    width: 100vw;
    top: fh(68vh, pc);
    left: 0;
    padding: fw(36vh, pc);
    background-color: #dee5ff;

    .view-line {
      width: 60%;
      display: flex;
      align-items: center;
      margin-left: 20%;

      .search-input {
        flex: 1;
        font-size: fh(14vh, pc);
        height: fh(48vh, pc);
        line-height: fh(48vh, pc);
      }

      .search-btn {
        width: 120px;
        height: fh(48vh, pc);
        line-height: fh(48vh, pc);
        background: #0046b4;
        font-size: fh(16vh, pc);
        text-align: center;
        border-radius: 10px;
        margin-left: 12px;
        color: white;

        &:hover {
          opacity: 0.8;
          cursor: pointer;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /* 高宽分别对应横竖滚动条的尺寸 */
  height: 8px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(219, 219, 219, 0.7);
  background: #d6d6d6;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  background: #ffffff;
}

.home_btn_back {
  margin-left: 600px !important;
}

.en {
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  sub,
  sup,
  tt,
  var,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  nav,
  .el-col,
  .el-row {
    // font-family: Arial, Helvetica, sans-serif;
    // font-family: "Times New Roman", Times, serif;
    // font-family: "SourceHanSansCN-Regular";
    font-family: "Inter", "SourceHanSansCN-Regular", "Microsoft YaHei", "微软雅黑", sans-serif;
  }

  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
    background-color: transparent;
    text-decoration: underline;
  }
}
</style>

<!-- 文章样式 -->
<style lang="scss">
.detail_content_info {
  // border-top: solid 1px #ccc;
  // border-bottom: solid 1px #ccc;
  margin-top: 16px;
  padding: 20px 0;
  // line-height: 22px;
  overflow-wrap: break-word;
  color: #333;
  // font-size: 14px;
  font-weight: normal;
  p {
    font-size: fh(18vh, pc);
    line-height: fh(30vh, pc);
    color: #333;
    font-weight: 400;
    margin: 16px 0;
  }
  .slide-title {
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    margin-top: fh(40vh, pc);
    margin-bottom: fh(20vh, pc);
    font-weight: bold;
  }
}

.detail_content_info img {
  width: 100%;
  height: 100%;
  display: inline-block;
  margin: 10px 0;
}
.en .detail-html p,
.en .detail-html section {
  line-height: 32px !important;
}

#detail .detail-html {
  text-align: justify;
}

.detail-html p,
.detail-html section {
  text-indent: 2em;
  text-justify: distribute-all-lines; /* 这行必加，兼容ie浏览器 */
  /* text-align-last: justify; */
}

.en .detail-html p,
.en .detail-html section {
  text-indent: 0;
}

.detail-html font {
  text-indent: 0 !important;
  /*display: block;*/
}
.mobile {
  .header-title {
    font-size: 26px !important;
    width: 100%;
    left: 0 !important;
    text-align: center;
  }
  .page-content {
    padding: fh(10vh, h5) !important;
    .slide-view {
      display: none !important;
    }
    .detail_title {
      padding-top: 20px !important;
      font-size: 24px !important;
      line-height: 28px !important;
    }
    .detail_content .slide-title {
      margin-top: 20px !important;
    }
    .detail_content_info p {
      margin: 5px 0 !important;
    }
    .sub-view .sub-item {
      padding: 10px !important;
      .sub-doc {
        font-size: 16px !important;
        line-height: 24px !important;
        .doc-item {
          margin-bottom: 8px !important;
        }
      }
      .sub-title {
        flex-wrap: wrap;
        font-size: 18px !important;
        width: 100%;
        margin-bottom: 5px !important;
        .year {
          width: 50%;
          margin: 0 !important;
          margin-top: 10px !important;
          font-size: 14px !important;
        }
        .country {
          width: 50%;
          margin-top: 10px;
          margin-left: auto !important;
          text-align: right;
          font-size: 14px !important;
        }
      }
    }
    .page-title {
      font-size: 20px !important;
      line-height: 24px !important;
      text-align: left !important;
    }
    .text {
      margin-bottom: 20px !important;
    }
  }
  .abs-line.fix {
    padding: fh(10vh, h5) !important;
    background-color: #0077d4;
    align-items: center;
    .logo-img {
      width: fw(26vw, h5);
    }
    .logo-title {
      font-size: fh(16vh, h5);
    }
    .right-btn {
      position: static;
      margin-left: auto;
    }
  }
}
.mobile {
  .drawer-fixed .el-drawer {
    width: 96%;
    left: 2% !important;
    top: 50% !important;
    height: max-content !important;
    transform: translateY(-50%);
  }
  .abs-line.fix-all.h5 {
    .logo-img {
      width: 50px !important;
    }
    .nav-item {
      width: 100vw;
      //border-bottom: 1px solid #fff;
      margin-bottom: 0px !important;
    }
    .sub-title {
      // margin-bottom: 16px !important;
      font-size: 20px !important;
      line-height: 28px !important;
      padding: 20px !important;
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      width: 100% !important;
      color: rgba(255, 255, 255, 0.54) !important;
      font-weight: bold;
      &.active {
        text-decoration: underline;
        text-underline-offset: 6px;
        color: #fff !important;
      }
      &:nth-last-child(1) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      }
    }
    .child-title {
      margin-top: 40px !important;
      margin-bottom: 20px;
      color: rgba(255, 255, 255, 0.5);
      &.active {
        color: #fff;
      }
    }
    .nav-all {
      width: 100%;
      height: 80vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 50px;
      .menu-view {
        text-align: center;
      }
    }
    .child-view {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px !important;
      .child-item {
        font-size: 14px !important;
        width: 50%;
        padding-right: 10px !important;
        padding-left: 20px !important;
        margin-bottom: 10px !important;
        line-height: 18px !important;
      }
    }
  }
}
.pdf-iframe {
  width: 100%;
  height: 100vh;
  margin-top: 30px;
}
/*.detail-html strong font*/
</style>
